import React from "react";


import { connect } from "react-redux";

class AccountLedgerSubComponent extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
		
		}
    }

	
    componentDidMount(){}
	componentWillUnmount(){
    }

  
    render(){
    console.log('Inside render');
    return(
        <div 
		class={this.props.etc=='debit'?"txncard dbt":"txncard cdt"}>  
		{/* other type= fld */}
					<div class="row">
						<div class="col-12 col-md-5 col-lg-4">
								<div class="txntype">
											<img src="images/dhbvn.png" alt="dhbvn"/>
											<h5>Dakshin Haryana Bijli Vitran Nigam</h5>	
											<p>Consumer no: 123456789</p>
											</div>
												</div>						
												
												<div class="col-12 col-md-3 col-lg-3">
													<div class="txntype">
														<h5 class="text-truncate">#FINXPAY123456789012</h5>
														<p>31-08-2020 17:56:09</p>
													</div>
												</div>
												<div class="col-6 col-md-2 col-lg">
													<div class="txntype">
														<p class="d-lg-none">Debit Amount</p>
														<h6 class="debit">₹ 2465.00</h6>
													</div>
												</div>
												<div class="col-lg d-none d-lg-block">
													<div class="txntype d-none">
														<p class="d-lg-none">Credit Amount</p>
														<h6 class="credit">₹ 2465.00</h6>
													</div>
												</div>
												
												<div class="col-6 col-md-2 col-lg">
													<div class="txntype text-end">
														<p class="d-lg-none">Balance</p>
														<h6>₹ 3,82,984.00</h6>
													</div>
												</div>
											</div>
										</div>
									
		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage,otpErrorMessage},
	 miscReduce:{otpRefNo,phone}}
	) => ({
		errorMessage,loginErrorMessage,otpErrorMessage,otpRefNo,phone
});

export default connect(mapStateToProps, null)(AccountLedgerSubComponent);
